import { render, staticRenderFns } from "./LandingFooterBar.vue?vue&type=template&id=a7037720&scoped=true&lang=pug"
import script from "./LandingFooterBar.vue?vue&type=script&lang=js"
export * from "./LandingFooterBar.vue?vue&type=script&lang=js"
import style0 from "./LandingFooterBar.vue?vue&type=style&index=0&id=a7037720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7037720",
  null
  
)

export default component.exports